// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iogZr","left":"styles_left__luk2o"};